﻿/**
 * authorization Module
 * @module authorizationModule
 * @namespace components.authorizationModule
 */

'use strict';

angular.module('components.authorizationModule', [
    'components.connectionsModule',
    'ngCookies',
    'restangular'
])
.factory('authorizationFactory', require('./authorizationFactory.js'));


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/authorization/index.js
// module id = 22
// module chunks = 0